/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AnyObjectName,
  ArrayEnrichmentProviderMetadata,
  EnrichmentProvider,
  EnrichmentWaterfallCreateRequest,
  EnrichmentWaterfallReplaceRequest,
  EnrichmentWaterfallView,
  MapString,
  OptionEnrichmentWaterfallView,
  PaginatedResultEnrichmentWaterfallView,
  StringifiedUsageRef,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "enrichment";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description attempts to find all waterfall views matching filters
   *
   * @tags Waterfall/Queries
   * @name FindAllWaterfallViews
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/waterfall
   * @secure
   */
  findAllWaterfallViews = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @example "Person" */
      name?: string;
      isTemplate?: boolean;
      "isCustom "?: boolean;
      /**
       * @pattern [^\s\\/]+
       * @example "PersonName"
       */
      forDataField?: string;
      /**
       * format: $type/$id
       *
       * possible types: RuleRef, ConciergeRouterRef
       * @example "ConciergeRouterRef/2fdf9549-bf68-4fde-8dc5-6ec7a48f2a40"
       */
      exclusiveFor?: StringifiedUsageRef;
      /**
       * format: $type/$id
       *
       * possible types: RuleRef, ConciergeRouterRef
       * @example "RuleRef/12341"
       */
      validFor?: StringifiedUsageRef;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultEnrichmentWaterfallView,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAllWaterfallViews */
  findAllWaterfallViewsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** @example "Person" */
      name?: string;
      isTemplate?: boolean;
      "isCustom "?: boolean;
      /**
       * @pattern [^\s\\/]+
       * @example "PersonName"
       */
      forDataField?: string;
      /**
       * format: $type/$id
       *
       * possible types: RuleRef, ConciergeRouterRef
       * @example "ConciergeRouterRef/2fdf9549-bf68-4fde-8dc5-6ec7a48f2a40"
       */
      exclusiveFor?: StringifiedUsageRef;
      /**
       * format: $type/$id
       *
       * possible types: RuleRef, ConciergeRouterRef
       * @example "RuleRef/12341"
       */
      validFor?: StringifiedUsageRef;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall`, query);

  /**
   * @description attempts to create waterfall definition
   *
   * @tags Waterfall/CRUD
   * @name CreateWaterfallDefinition
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/waterfall
   * @secure
   */
  createWaterfallDefinition = (
    tenantId: string,
    workspaceId: string,
    data: EnrichmentWaterfallCreateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      EnrichmentWaterfallView,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createWaterfallDefinition */
  createWaterfallDefinitionPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall`);

  /**
   * @description attempts to find waterfall definition for given id
   *
   * @tags Waterfall/CRUD
   * @name FindWaterfallDefinition
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/waterfall/{waterfallId}
   * @secure
   */
  findWaterfallDefinition = (tenantId: string, workspaceId: string, waterfallId: string, params: RequestParams = {}) =>
    this.request<
      OptionEnrichmentWaterfallView,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findWaterfallDefinition */
  findWaterfallDefinitionPathGetter = (tenantId: string, workspaceId: string, waterfallId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`);

  /**
   * @description attempts to replace waterfall definition
   *
   * @tags Waterfall/CRUD
   * @name ReplaceWaterfallDefinition
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/waterfall/{waterfallId}
   * @secure
   */
  replaceWaterfallDefinition = (
    tenantId: string,
    workspaceId: string,
    waterfallId: string,
    data: EnrichmentWaterfallReplaceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      EnrichmentWaterfallView,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceWaterfallDefinition */
  replaceWaterfallDefinitionPathGetter = (tenantId: string, workspaceId: string, waterfallId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`);

  /**
   * @description attempts to delete waterfall definition
   *
   * @tags Waterfall/CRUD
   * @name DeleteWaterfallDefinition
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/waterfall/{waterfallId}
   * @secure
   */
  deleteWaterfallDefinition = (
    tenantId: string,
    workspaceId: string,
    waterfallId: string,
    query?: {
      /** @default false */
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      EnrichmentWaterfallView,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWaterfallDefinition */
  deleteWaterfallDefinitionPathGetter = (
    tenantId: string,
    workspaceId: string,
    waterfallId: string,
    query?: {
      /** @default false */
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/waterfall/${waterfallId}`, query);

  /**
   * No description
   *
   * @tags Metadata
   * @name RetrieveAllMetadataForAllProvider
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/all-metadata
   * @secure
   */
  retrieveAllMetadataForAllProvider = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      ArrayEnrichmentProviderMetadata,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/all-metadata`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveAllMetadataForAllProvider */
  retrieveAllMetadataForAllProviderPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/all-metadata`);

  /**
   * No description
   *
   * @tags Metadata
   * @name RetrieveMetadataForRequestedProviders
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/metadata
   * @secure
   */
  retrieveMetadataForRequestedProviders = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      providers: EnrichmentProvider[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayEnrichmentProviderMetadata,
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/metadata`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveMetadataForRequestedProviders */
  retrieveMetadataForRequestedProvidersPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      providers: EnrichmentProvider[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/metadata`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | AnyObjectName
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
